export const MOOD_META = {
  petillant: { name: "Pétillant", emoji: "✨", tagline: "Pop acidulée, soleil, bonne humeur", color: "#FF6EC7" },
  chill: { name: "Chill", emoji: "🌊", tagline: "Lo-fi, bedroom pop, downtempo", color: "#F472B6" },
  focus: { name: "Focus", emoji: "🧠", tagline: "Instrumental, minimal, deep work", color: "#FBCFE8" },
  nostalgique: { name: "Nostalgique", emoji: "📼", tagline: "Rétro 80s / 90s / 2000s", color: "#FF9AC1" },
  fete: { name: "Fête", emoji: "🪩", tagline: "Dance, club, hits, afrobeats", color: "#FF52A3" },
  melancolique: { name: "Mélancolique", emoji: "🥀", tagline: "Doux-amer, piano, ballades", color: "#9D174D" },
};

export const CUSTOM_COLOR = "#FF2E93";

export const MOOD_IDEAS = [
  "Dimanche pluvieux sous un plaid",
  "Road trip au coucher du soleil",
  "Apéro en terrasse entre amis",
  "Ménage du samedi matin",
  "Balade nocturne en ville",
  "Cuisiner un dîner romantique",
  "Footing au lever du jour",
  "Main character energy",
];

export const getMoodMeta = (g) =>
  g.mood2
    ? { name: g.mood_name, emoji: "🪩", color: MOOD_META[g.mood]?.color || CUSTOM_COLOR }
    : g.mood === "custom"
    ? { name: g.mood_name, emoji: g.custom_emoji || "🪩", color: CUSTOM_COLOR }
    : MOOD_META[g.mood] || { name: g.mood_name || g.mood, emoji: "🪩", color: CUSTOM_COLOR };

export const formatDuration = (ms) => {
  const total = Math.round(ms / 1000);
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  if (h > 0) return `${h}h ${m.toString().padStart(2, "0")}min`;
  return `${m}min ${s.toString().padStart(2, "0")}s`;
};

export const formatMinSec = (ms) => {
  const total = Math.round(ms / 1000);
  const m = Math.floor(total / 60);
  const s = total % 60;
  return `${m}:${s.toString().padStart(2, "0")}`;
};
